import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' }
  ];

  const projectFilters = [
    { name: 'All Projects', path: '/#projects' },
    { name: 'Music', path: '/?filter=music#projects' },
    { name: 'Books', path: '/?filter=books#projects' },
    { name: 'Theatre', path: '/?filter=theatre#projects' }
  ];

  const handleFilterClick = (filter) => {
    toggleMenu();
    navigate('/');
    setTimeout(() => {
      // Trigger filter change
      const event = new CustomEvent('filterChange', { detail: filter });
      window.dispatchEvent(event);
      // Scroll to projects
      document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <>
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-sm border-b border-white/10">
        <div className="container mx-auto px-8 py-6 flex items-center justify-between">
          <button
            onClick={toggleMenu}
            className="p-2 hover:bg-white/5 transition-colors"
            aria-label="Toggle menu"
          >
            <Menu className="w-5 h-5 text-white" />
          </button>
          
          <Link to="/" className="text-sm font-light tracking-[0.3em] text-white hover:text-gold transition-colors">
            INFINITE REYN
          </Link>
          
          <div className="w-9"></div>
        </div>
      </header>

      {/* Sidebar Menu */}
      <div
        className={`fixed top-0 left-0 h-full w-80 bg-black z-[60] border-r border-white/10 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="p-8 flex flex-col h-full">
          <button
            onClick={toggleMenu}
            className="mb-12 p-2 hover:bg-white/5 transition-colors self-start"
            aria-label="Close menu"
          >
            <X className="w-5 h-5 text-white" />
          </button>

          <nav className="flex-1">
            {/* Main Menu */}
            <ul className="space-y-6 mb-12">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.path}
                    onClick={toggleMenu}
                    className="block text-2xl font-light text-white hover:text-gold transition-colors tracking-wider"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Divider */}
            <div className="w-16 h-px bg-gold mb-8"></div>

            {/* Project Filters */}
            <div className="mb-4">
              <p className="text-xs tracking-[0.3em] text-gold mb-4">EXPLORE PROJECTS</p>
              <ul className="space-y-4">
                {projectFilters.map((filter, index) => (
                  <li key={index}>
                    <button
                      onClick={() => handleFilterClick(filter.name.toLowerCase().replace(' projects', '').replace(' ', ''))}
                      className="block text-lg font-light text-white/70 hover:text-white transition-colors"
                    >
                      {filter.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Footer in Menu */}
          <div className="mt-auto pt-8 border-t border-white/10">
            <p className="text-xs text-white/40 tracking-wider">
              WHERE STORIES TAKE FORM
            </p>
          </div>
        </div>
      </div>

      {/* Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-[55] transition-opacity duration-300"
          onClick={toggleMenu}
        ></div>
      )}
    </>
  );
};

export default Navigation;
